export class OphtixParser {
    parseFile(file) {
        console.log(`Ophtix need to be implemented`);
    }

    parseData(data) {
        console.log(`Rufus need to be implemented`);
    }
}